<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    viewBox="0 0 24 24"
    fill="none">
    <circle
      cx="12"
      cy="12"
      r="7.5"
      fill="currentColor"
      fill-opacity="0.4"
      stroke="currentColor"></circle>
  </svg>
</template>
